import React from "react";
import FeatureSection from "../components/FeatureSection";

const featureImage1 =
  "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b0d_Frame%203.png";
const featureImage2 =
  "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fbd20754dab4a7f8ecaad3_Group%201000005200.png";

function SurveyPage() {
  return (
    <div className="flex flex-col">
      {/* Section 1 */}
      <FeatureSection
        image={featureImage1}
        title="
      AI Generated Surveys
      "
        description="
You can create AI-generated surveys to streamline data collection and gain valuable insights for your business.
      
      "
      />

      {/* Section 2 */}
      <FeatureSection
        image={featureImage2}
        title="
Real-Time Feedback That Works for You
      
      "
        description="
Leverage AI-powered surveys to simplify data collection and uncover meaningful insights for your organization.
      
      "
        reverse
      />
    </div>
  );
}

export default SurveyPage;
